export default function Quarantine() {
  return (
    <div className="h-100 d-flex flex-column justify-content-center align-items-center">
      <h1 className="mb-4 text-center d-flex justify-content-center" style={{ maxWidth: 800 }}>Thanks for signing up for Briefpoint’s free trial!</h1>
      <p className="mb-2" style={{ maxWidth: 800 }}>In order to ensure the best experience for all of our users, we need to to verify a few things about your account. Look for an email letting you know when you can start maximizing your productivity with Briefpoint!</p>
      <p className="mb-2" style={{ maxWidth: 800 }}>If you do not receive an email in the next 2 business days, please email us at <a href="mailto:support@briefpoint.ai?subject=Quarantine">support@briefpoint.ai</a> for assistance.</p>
    </div>
  );
}
